/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CreateVersionRequestFromJSON(json) {
    return CreateVersionRequestFromJSONTyped(json, false);
}
export function CreateVersionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: json['name'],
        hexColor: json['hexColor'],
        order: !exists(json, 'order') ? undefined : json['order'],
        active: json['active'],
    };
}
export function CreateVersionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name,
        hexColor: value.hexColor,
        order: value.order,
        active: value.active,
    };
}
